export default "__VITE_ASSET__Cm70uwke__"